import { render } from "./OptionView.vue?vue&type=template&id=1d650aa4&scoped=true"
import script from "./OptionView.vue?vue&type=script&lang=js"
export * from "./OptionView.vue?vue&type=script&lang=js"

import "./OptionView.vue?vue&type=style&index=0&id=1d650aa4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d650aa4"]])

export default __exports__